export default __webpack_public_path__ + "static/media/partner-rebecca.cf6f6b91.jpg";